// Store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

// Load initial state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('reduxState', serializedState);
  } catch {
    // ignore errors
  }
};

const persistedState = loadState();

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  preloadedState: persistedState
});

// Subscribe to store changes to save to localStorage
store.subscribe(() => {
  saveState(store.getState());
});

export default store;